import {
  GET_SINGLE_REQUEST_WORKFLOW_PENDING,
  GET_SINGLE_REQUEST_WORKFLOW_FULFILLED,
  GET_SINGLE_REQUEST_WORKFLOW_REJECTED,
  RESET_SINGLE_REQUEST_WORKFLOW,
} from "../actions/types";

const initialState = {
  data: {},
  loading: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_SINGLE_REQUEST_WORKFLOW_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_SINGLE_REQUEST_WORKFLOW_FULFILLED:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
      };
    case GET_SINGLE_REQUEST_WORKFLOW_REJECTED:
      return {
        ...state,
        data: {},
        loading: false,
        error: true,
      };

    case RESET_SINGLE_REQUEST_WORKFLOW:
      return {
        ...state,
        data: {},
        loading: false,
        error: false,
      };
    default:
      return state;
  }
}
